/* eslint-disable class-methods-use-this */
import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ProfileService, BaseUserService } from "@smarterplan/ngx-smarterplan-core";

@Component({
    selector: "app-museum-auth-pseudo",
    templateUrl: "./museum-auth-pseudo.component.html",
    styleUrls: ["./museum-auth-pseudo.component.scss"],
})
export class MuseumAuthPseudoComponent implements OnInit {
    @Input() templateID: string;

    pseudoValue: string;

    pseudoValueTooLong = false;

    pseudoValueIsMandatory = false;

    constructor(
        private profileService: ProfileService,
        private router: Router,
        private userService: BaseUserService,
    ) { }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ngOnInit(): void { }

    async handlePseudoInput() {
        const pseudoInput = document.querySelector(
            ".pseudo",
        ) as HTMLInputElement;
        this.pseudoValue = pseudoInput.value.trim();
        if (this.pseudoValue.length <= 20 && this.pseudoValue.length >= 1) {
            const updProfile = await this.profileService.updateProfile({
                id: this.userService.cu.id,
                pseudo: this.pseudoValue,
            });
            this.userService.updateCurrentUser(updProfile);
            this.router.navigate(["waiting", this.templateID]);
        } else {
            if (this.pseudoValue.length === 0) {
                this.pseudoValueIsMandatory = true;
                this.pseudoValueTooLong = false;
            }
            if (this.pseudoValue.length > 20) {
                this.pseudoValueIsMandatory = false;
                this.pseudoValueTooLong = true;
            }
        }
    }

    closeErrorMessage() {
        this.pseudoValueIsMandatory = false;
        this.pseudoValueTooLong = false;
    }
}
